/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # User Address Book functionality

define('modules/User/AddressBook',[
    'jquery',
    'lodash',
    'global/all',
    './AddressBook.Forms'
], function ($, _, Roc, AddressBookForms) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var addressType;
    var viewModel = {};
    var forms = AddressBookForms;

    /* Helpers UI */

    function checkEmptyResultsDisplay() {
        Roc.UI.checkEmptyResultsDisplay(viewModel);
    }

    function removeFromUi(editId) {
        Roc.UI.removeItemFromUi(editId, viewModel);
    }

    function closeForm() {
        Roc.UI.closeForm(viewModel.formSelector);
    }

    function openForm() {
        Roc.UI.openForm(viewModel.formSelector);
    }

    /* ViewModel related */

    function getEditId() {
        return $(viewModel.formPannelSelector).attr('data-editId');
    }

    function setEditId(id) {
        $(viewModel.formPannelSelector).attr('data-editId', id);
    }

    function clearEditId() {
        $(viewModel.formPannelSelector).removeAttr('data-editId');
    }

    function getAddressViewModel(addr) {
        if (viewModel.isCheckout) {
            addr.enableDefaultSelection = false;
            addr.enableSelection = true;
            addr.enableRemove = false;
        } else {
            addr.enableSelection = false;
        }

        addr.btnUseThis = viewModel.btns.btnUseThis;
        addr.btnSelected = viewModel.btns.btnSelected;
        if (addr.paymentMethods) {
            $.each(addr.paymentMethods, function (i, method) {
                method.cardName = Roc.CreditCard.getCreditCardName(method.cardType);
                method.cardCssClass = Roc.CreditCard.getCreditCardCssClass(method.cardType);
            });
        }
        return addr;
    }

    function loadViewModelDetails() {
        $.each(viewModel.addressList, function (i, addr) {
            getAddressViewModel(addr);
        });
    }

    function updateAddressBook(addr, editId) {
        addr.isSelected = true;
        var addressViewModel = getAddressViewModel(addr);
        if (typeof editId !== 'undefined' && editId !== '') {
            //update address
            $.each(viewModel.addressList, function (i, v) {
                if (v.id === editId) {
                    viewModel.addressList[i] = addressViewModel;
                    return;
                }
            });

            Roc.UI.template(viewModel.entryTmpSelector, addressViewModel).then(function (renderedTemplate) {
                $(viewModel.listSelector + ' .item[data-id=' + editId + ']').replaceWith(renderedTemplate);
            });

        } else {
            // new address
            viewModel.addressList.push(addressViewModel);

            Roc.UI.template(viewModel.entryTmpSelector, addressViewModel).then(function (renderedTemplate) {
                $(viewModel.listSelector).append(renderedTemplate);
                checkEmptyResultsDisplay();
            });
        }
    }

    /* Events */

    function editAddressEvt(callback, groupSelector) {
        if (typeof groupSelector === 'undefined') {
            groupSelector = 'body';
        }

        $(document).on('click', '.editAddress', function () {
            var addressId = Roc.UI.getItemId(this);
            var addressObj = _.find(viewModel.addressList, { 'id': addressId});

            setEditId(addressId);
            $(groupSelector).find(viewModel.formPannelSelector + ' .panel-title .action').text('Update');
            Roc.Forms.loadDetails(addressId, forms.ShippingAddress, viewModel.addressList);
            openForm();

            Roc.UI.bindAddressAutoCompleteEvt(addressType, null, addressObj.country);
            Roc.UI.bindZipCodeLookUpEvt(addressType, null, addressObj.country);
            Roc.UI.updateRegionStateDisplay(addressType);

            if (typeof (callback) == 'function') {
                callback(addressId);
            }
        });
    }

    function removeAddressEvt() {
        $(document).on('click', '.removeAddress', function () {
            var addressId = Roc.UI.getItemId(this);
            Roc.UI.confirm('Are you sure you want to delete this item?', function () {
                $.ajax({
                    url: apiUrl + '/api/addressbook/' + addressId,
                    type: 'DELETE',
                    dataType: 'json',
                    contentType: 'application/json'
                }).always(function (xhr) {
                    Roc.Logger.info('AddressBook -> removeAddressEvt');
                    Roc.Logger.info(xhr);
                }).done(function () {
                    closeForm();
                    removeFromUi(addressId);
                }).fail(function (xhr) {
                    Roc.Logger.error(xhr);
                    Roc.UI.displayErrorPopup();
                });
            });
        });
    }

    function setDefaultEvt() {
        Roc.UI.btnUseThisClickEvt(viewModel.btns, function (addressId) {
            $.ajax({
                url: apiUrl + '/api/addressbook/set-default/' + addressId,
                type: 'POST',
                dataType: 'json',
                complete: function (xhr) {
                    Roc.Logger.info('AddressBook -> setDefaultEvt');
                    Roc.Logger.info(xhr);
                }
            });
        });
    }

    function closeFormEvt(callback) {
        Roc.UI.onCloseFormEvt(viewModel.formSelector, function () {
            var editId = getEditId();
            clearEditId();
            Roc.Forms.clearFormInputs(viewModel.formSelector);
            $('#' + addressType + '-country').val(window.RocConfig.defaultCountryCode).trigger(Roc.Events.general.CHANGE);
            Roc.UI.bindAddressAutoCompleteEvt(addressType, null, window.RocConfig.defaultCountryCode);
            Roc.UI.bindZipCodeLookUpEvt(addressType, null, window.RocConfig.defaultCountryCode);
            Roc.UI.updateRegionStateDisplay(addressType);

            $('.panel-title .action').text('Add');
            if (typeof (callback) === 'function') {
                callback(editId);
            }
        });
    }

    function openFormEvt(callback) {
        Roc.UI.onOpenFormEvt(viewModel.formSelector, function () {
            Roc.UI.updateRegionStateDisplay(addressType);
            if (typeof (callback) === 'function') {
                callback();
            }
        });
    }

    function cancelFormEvt() {
        $(document).on('click', '#cancelAddressForm', function () {
            closeForm();
        });
    }

    function submitFormEvt(callback) {
        $(document).on('click', '#submitAddressForm', function (e) {
            var data = Roc.Forms.getFormValues(forms.ShippingAddress);
            var submitButton = e.currentTarget;

            if (!Roc.Validation.validateForm(forms.ShippingAddress)) {
                return;
            }

            Roc.Core.lockButton(submitButton);

            var id = getEditId();
            if (id) {
                data.id = id;
            }

            updateOrCreateAddressBook(data, function (xhr) {                
                var response = xhr.responseJSON || {};
                if (xhr.status === 200 || xhr.status === 201) {
                    closeForm();
                    if (!data.id && viewModel.canAddOrganizationAddresses) {
                        response.isDefault = false;
                    }

                    updateAddressBook(response, id);

                    if (typeof (callback) === 'function') {
                        callback(response);
                    }
                } else {
                    Roc.UI.ajaxErrorPopup(xhr);
                }

                Roc.Core.releaseLockedButton(submitButton);
            });
        });
    }

    function updateOrCreateAddressBook(data, callback) {
        var httpMethod = data.id ? 'PUT' : 'POST';

        $.ajax({
            url: apiUrl + '/api/addressbook/',
            data: JSON.stringify(data),
            type: httpMethod,
            dataType: 'json',
            contentType: 'application/json',
            complete: function (xhr) {
                Roc.Logger.info('AddressBook -> submitFormEvt');
                Roc.Logger.info(xhr);
                callback(xhr);
            }
        });
    }

    function bindEvents(callbacks) {
        var cbs = callbacks;

        editAddressEvt((cbs && cbs.editAddressCallback) ? cbs.editAddressCallback : null);
        closeFormEvt((cbs && cbs.closeFormCallback) ? cbs.closeFormCallback : null);
        openFormEvt((cbs && cbs.openFormCallback) ? cbs.openFormCallback : null);
        submitFormEvt((cbs && cbs.submitFormCallback) ? cbs.submitFormCallback : null);
        cancelFormEvt();
        Roc.UI.bindAddressFormEvents(addressType, null, (cbs && cbs.addressChangedCallback) ? cbs.addressChangedCallback : null);
    }

    function bindMyAccountEvents() {
        bindEvents({
            openFormCallback: function () {
                Roc.UI.scrollTo(viewModel.formPannelSelector, -60);
            },

            closeFormCallback: function () {
                Roc.UI.scrollTo('body', 0);
            }
        });

        setDefaultEvt();
        removeAddressEvt();
    }

    /* Init */

    function baseInit(model) {
        addressType = 'shipping';
        viewModel = {
            countries: model.countries,
            defaultCountryCode: window.RocConfig.defaultCountryCode,
            enableInternationalShipping: window.RocConfig.shipping.enableInternationalShipping,
            states: model.states,
            addressList: model.addresses || {},
            addressType: addressType,
            formSelector: '#' + addressType + '-address-form',
            formPannelSelector: '#' + addressType + '-form-panel',
            listSelector: '#' + addressType + '-address-list',
            entryTmpSelector: '#address-Tmp',
            emptyResultsSelector: '#noEntryMsg',
            canAddOrganizationAddresses: model.canAddOrganizationAddresses,
            canEditOrganizationAddresses: model.canEditOrganizationAddresses,

            btns: {
                btnUseThis: { cssClass: 'setDefault', text: 'Set as default address' },
                btnSelected: { cssClass: 'default', text: 'Default shipping address' }
            }
        };
        viewModel.addressList = _.filter(viewModel.addressList, 'enableShipping');
        viewModel.states = _.filter(viewModel.states, 'enableShipping');
    }

    function initMyAccount(model) {
        baseInit(model);
        loadViewModelDetails();

        var addressBookWrapperSelector = '#addressBookWrapper';
        var addressBookWrapperContainer = $(addressBookWrapperSelector);

        Roc.UI.block(addressBookWrapperSelector);

        Roc.UI.renderFormTemplate('#userAddressBook-Tmp', viewModel, addressBookWrapperContainer).then(function () {
            Roc.UI.unblock(addressBookWrapperSelector);
            bindMyAccountEvents();
        });
    }

    function bindCheckoutEvents(callbacks) {
        bindEvents(callbacks);
        if (viewModel.expandShippingForm) {
            populateShippingAddress();
        }
    }

    function populateShippingAddress() {
        Roc.Forms.populateData(viewModel.shippingAddress, forms.ShippingAddress);
    }

    function initCheckout(model) {
        baseInit(model);
        viewModel.isCheckout = true;
        viewModel.btns = {
            btnUseThis: { cssClass: 'useThisShippingAddress', text: 'Use this address' },
            btnSelected: { cssClass: 'selectedShippingAddres', text: 'Selected address' }
        };

        loadViewModelDetails();
        viewModel.shippingAddress = model.order.recipients[0];
        viewModel.shippingAddress.isDefault = false;
        viewModel.form = forms.ShippingAddress;
        viewModel.expandShippingForm = model.expandShippingForm;
        return viewModel;
    }

    var AddressBook = {
        initMyAccount: initMyAccount,
        initCheckout: initCheckout,
        viewModel: viewModel,
        bindCheckoutEvents: bindCheckoutEvents,
        getEditId: getEditId,
        forms: forms,
        updateOrCreateAddressBook: updateOrCreateAddressBook
    };

    Roc.Logger.debug('AddressBook.js Loaded:', AddressBook);

    return AddressBook;
});

